import React from 'react';

import { Title as MetaTitle } from 'src/shared/components/Meta';
import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';

const Title = () => {
  const t = useTranslate(TranslationNamespace.SHARED);

  return <MetaTitle title={t('renderings.renderings')} />;
};

export { Title };
